import { ListItemText, Box, Button, FormControl, Input, InputLabel, MenuItem, Checkbox, Select, Stack, Table, TableBody, TableContainer, TableHead, TableSortLabel, TableRow, Typography, Tabs, Tab, TextField, Grid } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import ActionsBar from '../../../components/ActionsBar';
import Paper from '@mui/material/Paper'
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles'
import { useAtom, useAtomValue } from 'jotai';
import { authAtom, servicessAtom, staffsAtom, tokenAtom } from '../../../actions';
import axios from 'axios';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import { convertMoney, hasPermission, showConfirmationToast } from '../../../utils/utils';
import DateRangeModal from '../Payments/modals/DateRangeModal';
import StaffReportItem from './components/StaffReportItem';
import { visuallyHidden } from '@mui/utils'
import { MultiSelect } from "react-multi-select-component";
import { Download, Upload } from '@mui/icons-material';
import * as XLSX from 'xlsx'
import StaffReportTotalItem from './components/StaffReportTotalItem';
import { useHistory } from 'react-router-dom';
import AddStaffReportModal from './modals/AddStaffReportModal';
import { DatePicker, LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DailyReportItem from './components/DailyReportItem';
import { min } from 'date-fns';
import AddDailyReportFileModal from './modals/AddDailyReportFileModal';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const headCells = [
    {
        id: 'full_name',
        paddingRight: false,
        disablePadding: false,
        label: 'Nhân viên',
    },
    {
        id: 'total_lead',
        paddingRight: true,
        disablePadding: false,
        label: 'Lead',
    },
    {
        id: 'completed_lead',
        paddingRight: true,
        disablePadding: false,
        label: 'Hoàn thành',
    },
    {
        id: 'order',
        paddingRight: true,
        disablePadding: false,
        label: 'Đơn hàng',
    },
    {
        id: 'totalPrice',
        paddingRight: true,
        disablePadding: false,
        label: 'Doanh thu',
    },
    {
        id: 'message',
        paddingRight: true,
        disablePadding: false,
        label: 'Tương tác',
    },
    {
        id: 'comission',
        paddingRight: true,
        disablePadding: false,
        label: 'Hoa hồng',
    },
];

const dailyHeadCells = [
    {
        id: 'button',
        paddingRight: false,
        disablePadding: false,
        label: '',
        minWidth: '80px',
    },
    {
        id: 'index',
        paddingRight: false,
        disablePadding: false,
        label: 'STT',
        minWidth: '60px',
    },
    {
        id: 'full_name',
        paddingRight: false,
        disablePadding: false,
        label: 'Họ tên',
        minWidth: '100px',
    },
    {
        id: 'username',
        paddingRight: false,
        disablePadding: false,
        label: 'SĐT',
        minWidth: '100px',
    },
    {
        id: 'source',
        paddingRight: false,
        disablePadding: false,
        label: 'Nguồn',
        minWidth: '100px',
    },
    {
        id: 'source_detail',
        paddingRight: false,
        disablePadding: false,
        label: 'Chi tiết nguồn',
        minWidth: '140px',
    },
    {
        id: 'user_identifier',
        paddingRight: false,
        disablePadding: false,
        label: 'Số CCCD',
        minWidth: '120px',
    },
    {
        id: 'past_services',
        paddingRight: false,
        disablePadding: false,
        label: 'Dịch vụ đã sử dụng',
        minWidth: '250px',
    },
    {
        id: 'feedback',
        paddingRight: false,
        disablePadding: false,
        label: 'Phản hồi',
        minWidth: '120px',
    },
    {
        id: 'status',
        paddingRight: false,
        disablePadding: false,
        label: 'Tình trạng KH',
        minWidth: '120px',
    },
    {
        id: 'new_services',
        paddingRight: false,
        disablePadding: false,
        label: 'Nhu cầu mới',
        minWidth: '200px',
    },
    {
        id: 'expected',
        paddingRight: false,
        disablePadding: false,
        label: 'Mong muốn',
        minWidth: '120px',
    },
    {
        id: 'new_orders_str',
        paddingRight: false,
        disablePadding: false,
        label: 'Chốt DV',
        minWidth: '120px',
    },
    {
        id: 'new_direct_income',
        paddingRight: false,
        disablePadding: false,
        label: 'Doanh thu trực tiếp',
        minWidth: '120px',
    },
    {
        id: 'new_other_income',
        paddingRight: false,
        disablePadding: false,
        label: 'Doanh thu khác',
        minWidth: '120px',
    },
    {
        id: 'income_category',
        paddingRight: false,
        disablePadding: false,
        label: 'Phân loại doanh thu',
        minWidth: '120px',
    },
    {
        id: 'note',
        paddingRight: false,
        disablePadding: false,
        label: 'Ghi chú',
        minWidth: '120px',
    },
    {
        id: 'booking_date',
        paddingRight: false,
        disablePadding: false,
        label: 'Lịch đặt',
    },
];

const TabPanel = ({ children, value, index, ...other }) => {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: { xs: 1, md: 3 } }}>
                    {children}
                </Box>
            )}
        </div>
    );
};

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, staffs } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow sx={{ position: 'sticky', top: 0, zIndex: 2 }}>
                {headCells.map((headCell) => (
                    <StyledTableCell
                        key={headCell.id}
                        align={headCell.paddingRight ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={{ fontSize: { xs: '10px', md: '14px' } }}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                            sx={{
                                '&.MuiTableSortLabel-root': {
                                    color: 'white',
                                },
                                '&.MuiTableSortLabel-root:hover': {
                                    color: 'white',
                                },
                                '&.Mui-active': {
                                    color: 'white',
                                },
                                '& .MuiTableSortLabel-icon': {
                                    color: 'white !important',
                                },
                            }}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </StyledTableCell>
                ))}
            </TableRow>

            <StaffReportTotalItem staffs={staffs} />
        </TableHead>
    );
}

function DailyTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow sx={{ position: 'sticky', top: 0, zIndex: 2 }}>
                {dailyHeadCells.map((headCell) => (
                    <StyledTableCell
                        key={headCell.id}
                        align={headCell.paddingRight ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={{ fontSize: { xs: '10px', md: '14px' }, minWidth: headCell?.minWidth ?? '100px' }}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                            sx={{
                                '&.MuiTableSortLabel-root': {
                                    color: 'white',
                                },
                                '&.MuiTableSortLabel-root:hover': {
                                    color: 'white',
                                },
                                '&.Mui-active': {
                                    color: 'white',
                                },
                                '& .MuiTableSortLabel-icon': {
                                    color: 'white !important',
                                },
                            }}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </StyledTableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

const Menu = (props) => {
    const { isAllSelected, options, ...menuProps } = props;

    return (
        <Select.Menu {...menuProps}>
            <MenuItem
                value="all"
                onClick={() => {
                    if (isAllSelected) {
                        menuProps.onClose();
                    } else {
                        menuProps.onChange(options.map((option) => option.id));
                    }
                }}
            >
                <Checkbox checked={isAllSelected} />
                <ListItemText primary="Tất cả" />
            </MenuItem>
            {props.children}
        </Select.Menu>
    );
}

const Screen = () => {
    const [total, setTotal] = useState(0)
    const [token] = useAtom(tokenAtom)
    const [staffReports, setStaffReports] = useState([])
    const [leadReports, setLeadReports] = useState([])
    const [selectedStaffs, setSelectedStaffs] = useState([])
    const [staffs] = useAtom(staffsAtom)
    const [dateRangeModal, setDateRangeModal] = useState(false)
    const [startDate, setStartDate] = useState(dayjs().subtract(90, 'days').format())
    const [endDate, setEndDate] = useState(dayjs().format())
    const authUser = useAtomValue(authAtom)
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('totalPrice');
    const history = useHistory()
    const [tabIndex, setTabIndex] = useState(0);
    const [currentRate, setCurrentRate] = useState(null)
    const [rateList, setRateList] = useState([])
    const [firstTimeUsers, setFirstTimeUsers] = useState([])
    const [addStaffReportModal, setAddStaffReportModal] = useState(false)
    const [addDailyReportFileModal, setAddDailyReportFileModal] = useState(false)
    const [reportDate, setReportDate] = useState(dayjs(Date.now()))
    const [dailyReports, setDailyReports] = useState([])
    const [dailySelectedStaff, setDailySelectedStaff] = useState(authUser?.id)
    const services = useAtomValue(servicessAtom)

    const getRateList = () => {

        if (token) {
            axios.defaults.headers.common['Authorization'] = `Token ${token}`

            axios.post('accounts/customers/get_all_rating/', { rating: currentRate })
                .then((response) => {
                    if (response && response.data) {
                        setRateList(response.data.rates)
                    } else {
                        setRateList([])
                    }
                })
                .catch((error) => {
                    console.log({ error })
                    setRateList([])
                })
        }
    }

    useEffect(() => {
        if (authUser && hasPermission(authUser, ['view_rating'])) {
            getRateList()
        }
    }, [currentRate, token])

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    }

    const onChangeRange = (range) => {
        setStartDate(range.startDate)
        setEndDate(range.endDate)
        setDateRangeModal(false)
    }

    const getStaffReports = useCallback(() => {
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Token ${token}`

            axios.post('/accounts/reports/staff_reports/', {
                staffs: selectedStaffs.length > 0 ? selectedStaffs.map((item) => item.value) : null,
                startDate: dayjs(startDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                endDate: dayjs(endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
            }, {
                headers: {
                    'Authorization': `Token ${token}`
                }
            })
                .then((response) => {
                    if (response && response.data) {
                        setStaffReports(response.data)
                    } else {
                        setStaffReports([])
                    }
                })
                .catch((error) => {
                    console.log({ error })
                    setStaffReports([])
                })
        }
    }, [token, startDate, endDate, selectedStaffs])

    const getDailyReport = useCallback(() => {
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Token ${token}`

            axios.post('/accounts/reports/get_daily_reports/', {
                staff_id: dailySelectedStaff,
                report_date: dayjs(reportDate).format('YYYY-MM-DD'),
            }, {
                headers: {
                    'Authorization': `Token ${token}`
                }
            })
                .then((response) => {
                    if (response && response.data) {
                        setDailyReports(response.data)
                    } else {
                        setDailyReports([])
                    }
                })
                .catch((error) => {
                    console.log({ error })
                    setDailyReports([])
                })
        }
    }, [token, reportDate, dailySelectedStaff])

    const getFirstTimeUsers = useCallback(() => {
        if (token) {
            axios.post('accounts/customers/user_first_order/', {
                staffs: selectedStaffs.length > 0 ? selectedStaffs.map((item) => item.value) : null,
                startDate: dayjs(startDate).format('DD-MM-YYYY'),
                endDate: dayjs(endDate).format('DD-MM-YYYY')
            }, {
                headers: {
                    'Authorization': `Token ${token}`
                }
            })
                .then((response) => {
                    if (response && response.data) {
                        setFirstTimeUsers(response.data)
                    } else {
                        setFirstTimeUsers([])
                    }
                })
                .catch((error) => {
                    console.log({ error })
                    setFirstTimeUsers([])
                })
        }
    }, [token, startDate, endDate, selectedStaffs])

    const getLeadReports = useCallback(() => {
        if (token) {
            axios.post('/accounts/reports/lead_reports/', {
                staffs: selectedStaffs.length > 0 ? selectedStaffs.map((item) => item.value) : null,
                startDate: dayjs(startDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                endDate: dayjs(endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
            }, {
                headers: {
                    'Authorization': `Token ${token}`
                }
            })
                .then((response) => {
                    if (response && response.data) {
                        setLeadReports(response.data)
                    } else {
                        setLeadReports([])
                    }
                })
                .catch((error) => {
                    console.log({ error })
                    setLeadReports([])
                })
        }
    }, [token, startDate, endDate, selectedStaffs])

    const onDeleteReport = (index, report) => {
        if (token) {
            setDailyReports((prev) => {
                const newReports = [...prev]
                newReports.splice(index, 1)
                return newReports
            })

            axios.defaults.headers.common['Authorization'] = `Token ${token}`

            const toastId = toast.loading('Đang xoá báo cáo...')

            axios.post('/accounts/reports/delete_daily_report/', {
                report_id: report.id
            }, {
                headers: {
                    'Authorization': `Token ${token}`
                }
            })
                .then((response) => {
                    if (response && response.data) {
                        toast.update(toastId, { render: 'Xoá báo cáo thành công', type: 'success', isLoading: false, autoClose: 2000 })
                        getDailyReport()
                    } else {
                        toast.update(toastId, { render: 'Xoá báo cáo thất bại', type: 'error', isLoading: false, autoClose: 2000 })
                    }
                })
                .catch((error) => {
                    console.log({ error })
                    toast.update(toastId, { render: 'Xoá báo cáo thất bại', type: 'error', isLoading: false, autoClose: 2000 })
                })
        }
    }

    const onAddDailyReport = async (file, sheetName) => {
        if (file) {
            const toastId = toast.loading('Đang thêm báo cáo...')

            const formData = new FormData();
            formData.append('file', file);
            formData.append('report_date', dayjs(reportDate).format('YYYY-MM-DD'))
            formData.append('sheet_name', sheetName)

            try {
                const response = await axios.post('/accounts/reports/create_daily_report_with_leads/', formData, {
                    headers: {
                        'Authorization': `Token ${token}`,
                        'Content-Type': 'multipart/form-data',
                    },
                });
                getDailyReport()

                toast.update(toastId, { render: 'Thêm báo cáo thành công', type: 'success', isLoading: false, autoClose: 2000 })
            } catch (error) {
                console.error('Upload error:', error);
                toast.update(toastId, { render: 'Thêm báo cáo thất bại', type: 'error', isLoading: false, autoClose: 2000 })
            }
        }
    }

    // const onAddDailyReport = (phoneList) => {
    //     if (token) {
    //         axios.defaults.headers.common['Authorization'] = `Token ${token}`

    //         const toastId = toast.loading('Đang thêm báo cáo...')
    //         axios.post('/accounts/reports/create_daily_report_with_leads/', {
    //             report_date: dayjs(reportDate).format('YYYY-MM-DD'),
    //             phoneList: phoneList
    //         }, {
    //             headers: {
    //                 'Authorization': `Token ${token}`
    //             }
    //         })
    //             .then((response) => {
    //                 if (response && response.data) {
    //                     toast.update(toastId, { render: 'Thêm báo cáo thành công', type: 'success', isLoading: false, autoClose: 2000 })
    //                     getDailyReport()
    //                 } else {
    //                     toast.update(toastId, { render: 'Thêm báo cáo thất bại', type: 'error', isLoading: false, autoClose: 2000 })
    //                 }
    //             })
    //             .catch((error) => {
    //                 console.log({ error })
    //                 toast.update(toastId, { render: 'Thêm báo cáo thất bại', type: 'error', isLoading: false, autoClose: 2000 })
    //             })
    //     }
    // }

    const onUpdateDailyReportServices = (report, services) => {
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Token ${token}`
            const toastId = toast.loading('Đang cập nhật báo cáo...')
            axios.post('/accounts/reports/update_daily_report_services/', {
                report_id: report.id,
                service_ids: services.map((item) => item.value)
            }, {
                headers: {
                    'Authorization': `Token ${token}`
                }
            })

                .then((response) => {
                    if (response && response.data) {
                        toast.update(toastId, { render: 'Cập nhật báo cáo thành công', type: 'success', isLoading: false, autoClose: 2000 })
                        getDailyReport()
                    } else {
                        toast.update(toastId, { render: 'Cập nhật báo cáo thất bại', type: 'error', isLoading: false, autoClose: 2000 })
                    }
                })
                .catch((error) => {
                    console.log({ error })
                    toast.update(toastId, { render: 'Cập nhật báo cáo thất bại', type: 'error', isLoading: false, autoClose: 2000 })
                })
        }
    }


    useEffect(() => {
        getStaffReports()
        getLeadReports()
        getFirstTimeUsers()
        getDailyReport()
    }, [getStaffReports, getLeadReports, getFirstTimeUsers, getDailyReport])

    const onExportReport = () => {
        showConfirmationToast(`Chắc chắn tải về báo cáo từ ngày ${dayjs(startDate).format('DD/MM/YYYY')} đến ngày ${dayjs(endDate).format('DD/MM/YYYY')}?`,
            () => {
                const data = staffReports.sort((a, b) => order === 'asc' ? a[orderBy] > b[orderBy] : a[orderBy] < b[orderBy])
                const worksheet = XLSX.utils.json_to_sheet(data, { origin: 'A2' });
                const headers = ['ID', "Họ và tên", 'Số Lead được giao', 'Số lead hoàn thành', 'Số đơn hàng', 'Doanh số', 'Số tương tác khách hàng', 'Hoa hồng']
                worksheet['!merges'] = [
                    { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length } },
                ]
                XLSX.utils.sheet_add_aoa(worksheet, [[`Báo cáo từ ngày ${dayjs(startDate).format('DD/MM/YYYY')} đến ngày ${dayjs(endDate).format('DD/MM/YYYY')}`]], { origin: "A1" });
                XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A2" });
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
                XLSX.writeFile(workbook, `report-${dayjs(startDate).format('DD/MM/YYYY')}-${dayjs(endDate).format('DD/MM/YYYY')}.xlsx`);
            }, () => { })
    }

    const staffOptions = staffs.map((item) => ({ label: item.full_name, value: item.id }))

    if (!(authUser && hasPermission(authUser, ['view_report', 'view_report_all']))) {
        return <Stack sx={{ flex: 1, alignItems: 'center', justifyContent: 'center', margin: '32px' }}>Không có quyền truy cập</Stack>
    }

    return (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', maxWidth: '100%', width: '100%' }}>
            <Stack sx={{ padding: { xs: '8px', md: '16px' } }}>
                <ActionsBar title='Báo cáo' subTitle={`Thời gian từ ${dayjs(startDate).format('DD/MM/YYYY')} đến ${dayjs(endDate).format('DD/MM/YYYY')}`} />
                {tabIndex !== 2 &&
                    <Grid container spacing={2} sx={{ width: '100%', zIndex: 2 }}>
                        <Grid item xs={6} md={6}>

                            <Stack sx={{ width: '100%', cursor: 'pointer', borderBottom: '0.5px solid #cccccc', padding: '3px 5px', borderRadius: '5px' }} variant='standard' onClick={() => setDateRangeModal(true)}>
                                <InputLabel sx={{ fontSize: '10px' }}>Thời gian</InputLabel>
                                <Typography sx={{ fontSize: '12px' }}>{`${dayjs(startDate).format('DD/MM/YYYY')} - ${dayjs(endDate).format('DD/MM/YYYY')}`}</Typography>
                            </Stack>
                        </Grid>
                        <Grid item xs={6} md={6}>
                            {hasPermission(authUser, ['view_report_all']) && (
                                <Stack sx={{ zIndex: 20, fontSize: '12px', width: '100%' }}>
                                    <MultiSelect
                                        options={staffOptions}
                                        value={selectedStaffs}
                                        onChange={setSelectedStaffs}
                                        labelledBy="Chọn nhân viên"
                                        overrideStrings={{
                                            "allItemsAreSelected": "Tất cả",
                                            "clearSearch": "Xoá",
                                            "clearSelected": "Bỏ chọn",
                                            "search": "Tìm kiếm",
                                            "selectAll": "Chọn tất cả",
                                            "selectAllFiltered": "Chọn tất cả",
                                            "selectSomeItems": "Lựa chọn nhân viên"
                                        }}
                                    />
                                </Stack>
                            )}
                        </Grid>
                    </Grid>
                }
            </Stack>

            <Box sx={{ width: '100%', overflowX: 'auto' }}>
                <Tabs
                    value={tabIndex}
                    onChange={handleTabChange}
                    aria-label="Report Tabs"
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab label="Báo cáo trạng thái LEAD" />
                    <Tab label="Báo cáo theo sale" />
                    <Tab label="Báo cáo theo ngày" />
                    {hasPermission(authUser, ['view_rating']) && <Tab label="Đánh giá của khách hàng" />}
                    {hasPermission(authUser, ['view_first_time_user']) && <Tab label="Khách hàng dùng dịch vụ lần đầu" />}
                </Tabs>
            </Box>
            <TabPanel value={tabIndex} index={0}>
                <Stack sx={{ marginTop: '16px', gap: '24px', padding: { xs: '8px', md: '16px' } }}>
                    <Paper style={{ margin: { xs: '8px', md: '0px 24px' } }}>
                        <Stack sx={{ gap: '24px', margin: '16px' }}>
                            <Typography sx={{ fontWeight: '700', fontSize: '16px', textAlign: 'center' }}>Báo cáo trạng thái LEAD</Typography>
                            <Stack flexWrap='wrap' direction='row' sx={{ gap: '8px', rowGap: '16px' }} justifyContent='center'>
                                {leadReports.map((item) => {
                                    return (
                                        <Stack onClick={() => history.push(`leads?status=${item.id}`)} sx={{ cursor: 'pointer', minWidth: '180px', alignItems: 'center' }} key={item.id.toString()}>
                                            <Typography sx={{ fontSize: { xs: '16px', md: '24px' }, fontWeight: '800', textAlign: 'center' }}>{item.count}</Typography>
                                            <Typography sx={{ fontSize: { xs: '11px', md: '14px' }, textAlign: 'center' }}>{item.name}</Typography>
                                        </Stack>
                                    )
                                })}
                            </Stack>
                        </Stack>
                    </Paper>
                </Stack>
            </TabPanel>

            <TabPanel value={tabIndex} index={1}>
                <Stack sx={{ gap: '24px', }}>
                    <Paper>
                        <Stack sx={{ gap: '16px' }}>
                            <Stack direction="row" justifyContent="flex-end">
                                {hasPermission(authUser, 'export_report_all') && (
                                    <Button onClick={onExportReport} sx={{ position: 'relative', right: { xs: '0', md: '32px' }, fontSize: { xs: '12px', md: 'inherit' } }}>
                                        <Download />
                                    </Button>
                                )}
                            </Stack>
                            <TableContainer component={Paper} sx={{ overflowY: 'auto', width: '100%', maxHeight: { xs: '60vh', md: '60vh' } }}>
                                <Table stickyHeader aria-label="simple table">
                                    <EnhancedTableHead
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleRequestSort}
                                        rowCount={total}
                                        staffs={staffReports}
                                    />
                                    <TableBody>
                                        {
                                            staffReports.sort((a, b) => order === 'asc' ? a[orderBy] > b[orderBy] : a[orderBy] < b[orderBy]).map((staff) => {
                                                return (
                                                    <StaffReportItem
                                                        staff={staff}
                                                    />
                                                )
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Stack>
                    </Paper>
                </Stack>
            </TabPanel>

            <TabPanel value={tabIndex} index={2}>
                <Stack sx={{ marginTop: '16px', gap: '24px', padding: { xs: '8px', md: '16px' } }}>
                    <Grid container spacing={2} sx={{ width: '100%', zIndex: 2 }}>
                        <Grid item xs={6} md={3}>
                            <FormControl sx={{ width: { xs: '100%', md: '100%' } }}>
                                <InputLabel sx={{ fontSize: { xs: '12px', md: '14px' } }}>Chọn ngày</InputLabel>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <MobileDatePicker
                                        value={reportDate}
                                        onChange={(newValue) => setReportDate(newValue)}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </LocalizationProvider>
                            </FormControl>

                        </Grid>
                        {hasPermission(authUser, ['view_all_daily_report']) && (
                            <Grid item xs={6} md={3}>

                                <FormControl sx={{ width: { xs: '100%', md: '100%' } }}>
                                    <InputLabel sx={{ fontSize: { xs: '12px', md: '14px' } }}>Chọn nhân viên</InputLabel>
                                    <Select
                                        value={dailySelectedStaff}
                                        onChange={(event) => setDailySelectedStaff(event.target.value)}
                                        label="Chọn nhân viên"
                                        sx={{ height: '55px' }}
                                    >
                                        {staffOptions.map((item) => (
                                            <MenuItem key={item.value} value={item.value}>
                                                <ListItemText primary={item.label} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        )}
                        <Grid item xs={3} md={3}>
                            <Button
                                variant="contained"
                                color='success'
                                endIcon={<Download />}
                                onClick={() => {
                                    const data = dailyReports.sort((a, b) => order === 'asc' ? a[orderBy] > b[orderBy] : a[orderBy] < b[orderBy]);
                                    
                                    const worksheet = XLSX.utils.json_to_sheet(data.map((report, index) => {
                                        const pastServicesString = report?.past_orders?.map((item) => {
                                            return `${item.service.name} - ${dayjs(item.order_date).format('DD/MM/YYYY')}`
                                        }).join(', ')

                                        const newServicesString = report?.new_services?.map((item) => {
                                                return `${item.name}`
                                            }).join(', ')
                                        
                                        return{
                                        "STT": index + 1,
                                        "Họ tên": report?.lead?.user?.full_name,
                                        "SĐT": report?.lead?.user?.username,
                                        "Nguồn": report?.source?.source?.name,
                                        "Dịch vụ đã sử dụng": pastServicesString,
                                        // "Thời gian dịch vụ": report.past_services_time,
                                        "Phản hồi": report.feedback,
                                        "Nhu cầu": report.new_demand,
                                        "Mong muốn": report.expected,
                                        "Tình trạng": report.status,
                                        "Chốt DV": newServicesString,
                                        "Doanh thu trực tiếp": report.new_direct_income,
                                        "Doanh thu khác": report.new_other_income,
                                        "Loại doanh thu": report.income_category,
                                        "Ghi chú": report.note,
                                        "Lịch đặt": report.booking_date,
                                    }}));
                                    const headers = ["STT", "Họ tên", "SĐT", "Nguồn", "Dịch vụ đã sử dụng", "Phản hồi", "Nhu cầu", "Mong muốn", "Tình trạng", "Chốt DV", "Doanh thu trực tiếp", "Doanh thu khác", "Loại doanh thu", "Ghi chú", "Lịch đặt"];
                                    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });
                                    const workbook = XLSX.utils.book_new();
                                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Daily Reports');
                                    XLSX.writeFile(workbook, `Báo cáo ngày - ${dayjs(reportDate).format('DD-MM-YYYY')}.xlsx`);
                                }}
                                sx={{ height: '45px', width: { xs: '100%', md: '100%' } }}
                            >
                                Xuất Báo Cáo
                            </Button>
                        </Grid>
                        {/* <Grid item xs={3} md={3}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setAddStaffReportModal(true)}
                                sx={{ height: '45px', width: { xs: '100%', md: '100%' } }}
                            >
                                Thêm KH
                            </Button>
                        </Grid> */}
                        <Grid item xs={3} md={3}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    setAddDailyReportFileModal(true)
                                }}
                                sx={{ height: '45px', width: { xs: '100%', md: '100%' } }}
                                endIcon={<Upload />}
                                disabled={!hasPermission(authUser, ['create_daily_report_everytime']) && dayjs().isAfter(dayjs(reportDate).utcOffset(7).hour(19))}
                            >
                                Tải lên
                            </Button>
                        </Grid>
                    </Grid>
                    <AddStaffReportModal
                        open={addStaffReportModal}
                        onClose={() => setAddStaffReportModal(false)}
                        onSubmit={(phoneList) => {
                            console.log({ phoneList })
                            onAddDailyReport(phoneList)
                            setAddStaffReportModal(false);
                        }}
                    />
                    <AddDailyReportFileModal
                        visible={addDailyReportFileModal}
                        onClose={() => setAddDailyReportFileModal(false)}
                        onSubmit={({file, sheetName}) => {
                            console.log({ file, sheetName })
                            onAddDailyReport(file, sheetName)
                            setAddDailyReportFileModal(false);
                        }}
                    />
                    <Paper style={{ margin: { xs: '8px', md: '0px 24px' } }}>
                        <Stack sx={{ gap: '24px', margin: '16px' }}>
                            <TableContainer component={Paper} style={{ overflowY: 'scroll', width: '100%', overflowX: 'scroll', maxHeight: '60vh' }}>
                                <Table stickyHeader aria-label="simple table">
                                    <DailyTableHead
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleRequestSort}
                                        rowCount={total}
                                    />
                                    <TableBody>
                                        {
                                            (dailyReports ?? []).sort((a, b) => order === 'asc' ? a[orderBy] > b[orderBy] : a[orderBy] < b[orderBy]).map((report, index) => {
                                                return (
                                                    <DailyReportItem
                                                        index={index}
                                                        report={report}
                                                        onDelete={() => onDeleteReport(index, report)}
                                                        services={services}
                                                        onSelectServices={(services) => onUpdateDailyReportServices(report, services)}
                                                    />
                                                )
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Stack>
                    </Paper>
                </Stack>
            </TabPanel>

            <TabPanel value={tabIndex} index={3}>
                <Stack sx={{ marginTop: '16px', gap: '24px', padding: { xs: '8px', md: '16px' }, overflowX: { xs: 'auto', md: 'visible' } }}>
                    <Paper style={{ margin: { xs: '8px', md: '0px 24px' } }}>
                        <Stack sx={{ gap: '24px', margin: '16px' }}>
                            <Typography sx={{ fontWeight: '700', fontSize: '16px', textAlign: 'center' }}>Danh sách đánh giá</Typography>
                            <Stack width={'100%'} sx={{ overflowX: 'scroll' }} direction="row" spacing={2} justifyContent="center">
                                <Button
                                    key={'00'}
                                    variant={currentRate === null ? 'contained' : 'outlined'}
                                    onClick={() => setCurrentRate(null)}
                                >
                                    {`Tất cả đánh giá`}
                                </Button>
                                {[1, 2, 3, 4, 5].map((rate) => (
                                    <Button
                                        key={rate}
                                        variant={currentRate === rate ? 'contained' : 'outlined'}
                                        onClick={() => setCurrentRate(rate)}
                                    >
                                        {`Đánh giá ${rate} sao`}
                                    </Button>
                                ))}
                            </Stack>
                            <TableContainer component={Paper} style={{ overflowY: 'auto', width: '100%', overflowX: 'auto', maxHeight: '60vh' }}>
                                <Table stickyHeader aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Khách hàng</StyledTableCell>
                                            <StyledTableCell>SĐT</StyledTableCell>
                                            <StyledTableCell align="right">Dịch vụ</StyledTableCell>
                                            <StyledTableCell align="right">Thời gian</StyledTableCell>
                                            <StyledTableCell align="right">Đánh giá</StyledTableCell>
                                            <StyledTableCell align="right">Bình luận</StyledTableCell>
                                            <StyledTableCell align="right">KTV1</StyledTableCell>
                                            <StyledTableCell align="right">KTV2</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {(rateList ?? [])
                                            .map((rateItem, index) => (
                                                <TableRow key={index}>
                                                    <StyledTableCell>{rateItem?.service_book?.service_order?.user?.full_name}</StyledTableCell>
                                                    <StyledTableCell>{rateItem?.service_book?.service_order?.user?.username}</StyledTableCell>
                                                    <StyledTableCell align="right">{rateItem?.service_book?.service_order?.service_name ?? rateItem?.service_book?.service_order?.service?.name}</StyledTableCell>
                                                    <StyledTableCell align="right">{dayjs(rateItem?.service_book?.start_service_date).format('HH:mm DD/MM/YYYY')}</StyledTableCell>
                                                    <StyledTableCell align="right">{rateItem?.rate}</StyledTableCell>
                                                    <StyledTableCell align="right">{rateItem?.rate_note}</StyledTableCell>
                                                    <StyledTableCell align="right">{rateItem?.service_book?.technical_staff ? `${rateItem?.service_book?.technical_staff.full_name} - ${rateItem?.service_book?.technical_staff.username}` : ''}</StyledTableCell>
                                                    <StyledTableCell align="right">{rateItem?.service_book?.second_technical_staff ? `${rateItem?.service_book?.second_technical_staff.full_name} - ${rateItem?.service_book?.second_technical_staff.username}` : ''}</StyledTableCell>
                                                </TableRow>
                                            ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Stack>
                    </Paper>
                </Stack>
            </TabPanel>
            <TabPanel value={tabIndex} index={4}>
                <Stack sx={{ marginTop: '16px', gap: '24px', padding: { xs: '8px', md: '16px' } }}>
                    <Paper style={{ margin: { xs: '8px', md: '0px 24px' } }}>
                        <Stack sx={{ gap: '24px', margin: '16px' }}>
                            <Typography sx={{ fontWeight: '700', fontSize: '16px', textAlign: 'center' }}>Danh sách khách hàng lần đầu</Typography>
                            <TableContainer component={Paper} style={{ overflowY: 'auto', width: '100%', overflowX: 'auto', maxHeight: '60vh' }}>
                                <Table stickyHeader aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Khách hàng</StyledTableCell>
                                            <StyledTableCell align="right">Số điện thoại</StyledTableCell>
                                            <StyledTableCell align="right">Dịch vụ</StyledTableCell>
                                            <StyledTableCell align="right">Thời gian</StyledTableCell>
                                            <StyledTableCell align="right">Giá trị</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {firstTimeUsers.map((user, index) => (
                                            <TableRow key={index}>
                                                <StyledTableCell>{user?.user?.full_name}</StyledTableCell>
                                                <StyledTableCell align="right">{user?.user?.username}</StyledTableCell>
                                                <StyledTableCell align="right">{user?.service_name ?? user?.service?.name}</StyledTableCell>
                                                <StyledTableCell align="right">{dayjs(user?.order_date).format('HH:mm DD/MM/YYYY')}</StyledTableCell>
                                                <StyledTableCell align="right">{`${convertMoney(user?.price ?? 0)}đ`}</StyledTableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Stack>
                    </Paper>
                </Stack>
            </TabPanel>

            <DateRangeModal
                open={dateRangeModal}
                startDate={startDate}
                endDate={endDate}
                onConfirm={onChangeRange}
                handleClose={() => {
                    setDateRangeModal(false)
                }}
            />
        </div>
    )
}

export default Screen